import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class TextAreaField extends React.Component {
  static propTypes = {
    ...fieldPropTypes,
    label: PropTypes.string,
    type: PropTypes.string,
    maxLength: PropTypes.number,
    colorError: PropTypes.bool,
    autoResize: PropTypes.bool,
  };

  static defaultProps = {
    columnsCount: 1,
    label: '',
    type: 'text',
    maxLength: null,
    autoResize: false,
  };

  textArea = createRef();

  componentDidMount() {
    if (this.props.autoResize) {
      this.autoResize();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.input.value !== this.props.input.value &&
      this.props.autoResize
    ) {
      this.autoResize();
    }
  }

  autoResize = () => {
    this.textArea.current.style.height = '1px';
    this.textArea.current.style.height =
      this.textArea.current.scrollHeight + 'px';
  };

  render() {
    const {
      input,
      label,
      placeholder,
      maxLength,
      style = {},
      autoResize,
      dataTestId,
    } = this.props;

    if (autoResize) {
      style.overflowY = 'hidden';
    }

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <div className="input-component">
          {label && <span className="input-component__label">{label}</span>}
          <textarea
            {...input}
            style={{
              ...style,
            }}
            ref={this.textArea}
            value={input.value}
            placeholder={placeholder}
            onFocus={input.onFocus}
            onChange={(value) => {
              input.onChange(value);
              this.autoResize();
            }}
            onBlur={input.onBlur}
            maxLength={maxLength}
            name={input.name}
            data-testid={
              dataTestId
                ? `${dataTestId}-textarea`
                : input.name.toLowerCase().replace(/\s+/g, '-')
            }
          />
        </div>
      </ReduxFormElementWrapper>
    );
  }
}
